import {useContext, useEffect, useState} from "react";
import {SettingState} from "./interfaces/SettingState";
import SettingController from "./controller/SettingController";
import SettingHeader from "./view/SettingHeader";
import {MarketContext} from "../Main/context/MarketContext";
import {useNavigate, useParams} from "react-router-dom";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Theme from "./Theme";
import Desk from "./Desk";
import Other from "./Other";
import Discount from "./Discount";
import Printer from "./Printer";
import Payment from "./Payment";
import ExtraCosts from "./view/ExtraCosts/ExtraCosts";
import './assets/setting.scss'
import {useTranslation} from "react-i18next";
import {withLang} from "../../routes/LangLayout";

export default function Setting() {
    const context = useContext(MarketContext)
    const navigate = useNavigate();
    const {shopId, lang} = useParams();
    const {t} = useTranslation();
    const [state, setState] = useState<SettingState>({
        loading: true,
        error: false,
        activeTab: {label: t("setting.theme"), value: 'theme'},
    })
    const TabList = [
        {label: t("setting.theme"), value: 'theme', element: <Theme/>},
        {label: t("setting.desk"), value: 'desk', element: <Desk/>},
        {label: t("setting.discount"), value: 'discount', element: <Discount/>},
        {label: t("setting.printer"), value: 'printer', element: <Printer/>},
        {label: t("setting.payment"), value: 'payment', element: <Payment/>},
        {label: t("setting.extraCosts"), value: 'extraCosts', element: <ExtraCosts/>},
        {label: t("setting.other"), value: 'other', element: <Other/>},
    ];


    useEffect(() => {
        // validate setting gateway
        if (!context.state.isAccess) {
            navigate(withLang(`/${shopId}`, lang))
        }

        new SettingController(state, setState).getSetting().then()
    }, []);

    // loading
    if (state.loading)
        return (
            <section className={'loading'}>
                <div className="spinner"/>
            </section>
        )

    return (
        <div className={" setting-page"}>
            <section >
                <SettingHeader/>
                <div>
                    <Tabs defaultActiveKey={TabList[0].value} id="custom-tab-list" className="mb-3">
                        {TabList.map((tab) => (
                            <Tab eventKey={tab.value} title={tab.label} key={tab.value}>
                                {tab.element}
                            </Tab>
                        ))}
                    </Tabs>
                </div>
            </section>
        </div>
    );
}
